<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i class="fa fa-times" (click)="cancel()" style="cursor: pointer;"></i>
  </div>
</div>
<div class="modal-body" [hidden]="minimise">
  <form novalidate autocomplete="off">
    <div class="form-group">
      <label class="control-label"><strong>Filing Group:</strong></label>
      <select class="form-control" [(ngModel)]="filingGroups.selected" name="filing_group"
              [compareWith]="compareFilingGroup">
        <option [ngValue]="null" disabled>Select</option>
        @for (s of filingGroups.list; track $index) {
<option [ngValue]="s">{{ s.GROUP_NAME ?? s.FILING_GROUP }}</option>
}
      </select>
    </div>
    <div class="modal-footer">
      <button class="save-button" type="button" [disabled]="isSaveClicked" (click)="save()">
        @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
      </button>
      <button class="reset-button" type="button" (click)="reset()">Reset Form</button>
      <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
    </div>
  </form>
</div>
